import { useState, useEffect, useCallback } from "react";

import "./MusicActions.css";
import UploadAction from "./UploadAction";
import PlayAction from "./PlayAction";
import DownloadAction from "./DownloadAction";
import DeleteAction from "./DeleteAction";
import DeleteSongRecordAction from "./DeleteSongRecord";

import { formatSongTitle } from "./formatSongTitle";

function MusicActions({ item, event, onSongUpdate }: any) {
    const [localItem, setLocalItem] = useState(item);

    useEffect(() => {
        setLocalItem(item);
    }, [item]);
    
  const handleUploadSuccess = useCallback((updatedSong: any) => {
    setLocalItem((prev: any) => ({ ...prev, ...updatedSong }));
    //tell the outer page so global state reflects this change
    if (typeof onSongUpdate === "function") {
      onSongUpdate(updatedSong);
    }
  }, [onSongUpdate]);

/*const directorUploadLockDays = event.music_settings?.find(
  (setting: { key_name: string; value: number }) => setting.key_name === 'director_upload_lock_prior_days'
)?.value;*/
//const nowDate = new Date(Date.now());
//const [eventMonth, eventDay, eventYear] = event.start_date.split('/').map(Number);
//const eventDateObj = new Date(eventYear, eventMonth - 1, eventDay);
//const lockDays = parseInt(directorUploadLockDays);
//const maxUploadDate = new Date(eventDateObj);
//maxUploadDate.setDate(maxUploadDate.getDate() - lockDays);
//const formattedMaxUploadDate = `${String(maxUploadDate.getMonth() + 1).padStart(2, '0')}/${String(maxUploadDate.getDate()).padStart(2, '0')}/${maxUploadDate.getFullYear()}`;
// let lockDaysBoolean = nowDate >= maxUploadDate;

let lockDaysBoolean = !!event?.lock_songs;

const canPlayMusic = !!JSON.parse(localStorage.getItem("user") || '{}')?.modules?.find((m:any) => m.title.toLowerCase() === "music")?.ModulesPermissions?.view;
const canAddMusic = !!JSON.parse(localStorage.getItem("user") || '{}')?.modules?.find((m:any) => m.title.toLowerCase() === "music")?.ModulesPermissions?.add;
const canUploadMusic = canAddMusic;
const canDownloadMusic = canPlayMusic;
const canDeleteMusic = !!JSON.parse(localStorage.getItem("user") || '{}')?.modules?.find((m:any) => m.title.toLowerCase() === "music")?.ModulesPermissions?.delete;

const canDeleteMusicRecord = !!JSON.parse(localStorage.getItem("user") || '{}')?.modules?.find((m:any) => m.title.toLowerCase() === "eventsongs")?.ModulesPermissions?.delete;

const currentRole = JSON.parse(localStorage.getItem("user") || '{}').current_role;

if(currentRole==1) lockDaysBoolean = false;

  return (
    <div className="music-actions">
      {localItem.status === "ready" && canPlayMusic ? (
        <div className="uploaded-state">
          <PlayAction item={localItem} />
          <div className="song-name-container">
            <div className="tooltip-container">
              <span className="song-name-truncated">{formatSongTitle(localItem.song_title, localItem.performance?.entry_number ?? 0)}</span>
              <span className="tooltiptext">{formatSongTitle(localItem.song_title, localItem.performance?.entry_number ?? 0)}</span>
            </div>
          </div>
          <div className="actions-buttons">
            {canDownloadMusic && (<DownloadAction item={localItem} />)}
            {canDeleteMusic && (
            <DeleteAction
              item={localItem}
              lockDaysBoolean ={lockDaysBoolean}
              onUpdate={(updatedSong: any) => {
                console.log("updatedSong in MusicActions:", updatedSong);
                setLocalItem((prev: any) => ({ ...prev, ...updatedSong }));
                if (typeof onSongUpdate === "function") onSongUpdate(updatedSong);
              }}
            />
            )}
          </div>
        </div>
      ) : (
        <div className="not-uploaded-state">
          {canUploadMusic && (
          <UploadAction 
            item={localItem}
            lockDaysBoolean ={lockDaysBoolean}
            event={event} 
            onSuccess={handleUploadSuccess}
          />
          )}
          {(canDeleteMusicRecord) &&  (
            <DeleteSongRecordAction
              item={localItem}
              onUpdate={(updatedSong: any) => {
                console.log("Delete Song record in MusicActions:", updatedSong);
                setLocalItem((prev: any) => ({ ...prev, ...updatedSong }));
                if (typeof onSongUpdate === "function") onSongUpdate({ _deleted: true });
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default MusicActions;